angular.module('mercury.modules.reports.staff')
.controller('ReportsStaffOverviewCtrl', ["$filter", "PosVoids", "$q", "ReportPosStaff", "ReportSales", "reporttime", "$scope", "TimeClock", "title", "userinfo", function($filter, PosVoids, $q, ReportPosStaff, ReportSales, reporttime, $scope, TimeClock, title, userinfo) {
  title.set('Staff Overview');

  $scope.loading = $q.all({
    sales: ReportPosStaff.getSales(reporttime.start(), reporttime.end()),
    orders: ReportPosStaff.getOrders(reporttime.start(), reporttime.end()),
    staffCost: TimeClock.getSummaryByRole(reporttime.start(), reporttime.end()),
    discounts: ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval()),
    voids: PosVoids.getByReason(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(result) {
    $scope.showStaffCost = false;
    $scope.showStaffHours = false;
    // If the company has the 'permissions.timeAllowsSummary' preference enabled then staff cost will return an the total staffing cost amount
    // We dont want to show the total amount as then a user could calculate the peoples payrates but its okay to show the staff cost ratio.
    // Thus only users with Payroll permissions should be able to see the amount
    $scope.showStaffCostAmount = userinfo.companyHasPermission('Payroll');

    if (result.staffCost && result.staffCost[0] && result.staffCost[0].hasOwnProperty('cost')) {
      $scope.showStaffCost = true;
      $scope.staffCost = $filter('sumof')(result.staffCost, 'cost');
    } else if (result.staffCost && result.staffCost[0] && result.staffCost[0].hasOwnProperty('hours')) {
      $scope.showStaffHours = true;
      $scope.staffHours = $filter('sumof')(result.staffCost, 'hours');
    }

    var totalOrders = $filter('sumof')(result.orders, 'amount');
    angular.forEach(result.orders, function(staff) {
      staff.ordersPercent = (totalOrders !== 0) ? (staff.amount / totalOrders) * 100 : 0;
    });
    $scope.staffOrders = result.orders;
    $scope.sales = result.sales;

    var totalSales = $filter('sumof')(result.discounts, 'invoices');
    var totalSalesTax = $filter('sumof')(result.discounts, 'invoicesTax');

    $scope.staffCostGraph = [
      {label: 'Staff Cost', amount: $scope.staffCost},
      {label: 'Total Sales (ex GST)', amount: totalSales - $scope.staffCost > 0 ? totalSales - totalSalesTax - $scope.staffCost : 0}
    ];

    $scope.totalDiscounts = $filter('sumof')(result.discounts, 'discounts');
    $scope.totalVoids = $filter('sumof')(result.voids, 'voidAmount');
  });

  $scope.staffSalesColumns = [
    {label: 'Staff Member', type: 'string', key: 'label'},
    {label: 'Sales', type: 'number', key: 'invoices', filter: 'currency'}
  ];

  $scope.staffCostColumn = [
    {label: '', type: 'string', key: 'label'},
    {label: 'Amount', type: 'number', key: 'amount', filter: 'currency'}
  ];

  $scope.staffCostOptions = {
    sliceVisibilityThreshold: 0
  };
}]);
